// Draven — Spinning Axe: throws spinning axes that arc back to him.
// Gains +1 axe each cast, capped at 4. Each axe deals flat AD-based damage —
// no per-stack multiplier. Base AD is lower than average to compensate for ramp.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

const MAX_AXES = 4;

export const dravenSpinning: Ability = {
  id: "dravenSpinning",
  displayName: "Spinning Axe",
  description: "Gains +1 axe each cast (max 4). Each axe deals 0.845× AD + 10 physical damage.",
  iconId: "DravenQ",

  targetShape({ target }) {
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    const stats    = effectiveStats(caster);
    const axeCount = Math.min(caster.passiveStacks + 1, MAX_AXES);
    const dmg      = physicalDamage(stats.ad * 0.845 + 10);

    caster.passiveStacks = Math.min(caster.passiveStacks + 1, MAX_AXES);

    return Array.from({ length: axeCount }, () => ({
      target,
      amount: dmg,
      type:   "physical" as const,
      dravenAxe: true,
    }));
  },
};
